export default __webpack_public_path__ + "static/imgTwo-07542dfacbbf8e54104dbe04af3b9d78.jpg";